import { ELanguage } from './Language/languageHelper';

export enum EChatAgentMessageAuthor {
    USER = 'user',
    AI = 'ai',
}
export interface IChatAgentMessage {
    role: EChatAgentMessageAuthor;
    text: string;
}

export enum EAgentModule {
    GENERAL = 'general',
    ONBOARDING = 'onboarding',
    BUG_REPORT = 'bug_report',
}

export interface IAgentContext {
    module: EAgentModule;
    currentUrl?: string;
    chatId?: string; // Für Navigation mit Chat-Erhaltung
    subContext?: {
        employeeTalkId?: number;
        currentStep?: number;
        stepName?: string;
    };
}

export enum EChatAgentMessageEventType {
    START_CHAT = 'START_CHAT',
    USER_QUESTION = 'USER_QUESTION',
    AI_ANSWER = 'AI_ANSWER',
    INIT_CHAT = 'INIT_CHAT',
    CHAT_TITLE_GENERATED = 'CHAT_TITLE_GENERATED',
    GET_CHAT_LIST = 'GET_CHAT_LIST',
    CHAT_LIST_RESPONSE = 'CHAT_LIST_RESPONSE',
    LOAD_CHAT = 'LOAD_CHAT',
    NAVIGATE_TO = 'NAVIGATE_TO',
}

interface IChatAgentBaseEvent {
    type: EChatAgentMessageEventType;
    error?: string;
}
interface IChatAgentInitEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.INIT_CHAT;
    chat: IChatAgentChat;
}
interface IChatAgenStartChatEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.START_CHAT;
}
export interface IChatAgentMessageEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.AI_ANSWER | EChatAgentMessageEventType.USER_QUESTION;
    chatId: string;
    message: string;
    agentContext?: IAgentContext;
}
interface IChatAgentTitleGeneratedEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.CHAT_TITLE_GENERATED;
    chatId: string;
    title: string;
}
interface IChatAgentGetChatListEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.GET_CHAT_LIST;
}
interface IChatAgentChatListResponseEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.CHAT_LIST_RESPONSE;
    chats: IChatAgentChatMetadata[];
}
interface IChatAgentLoadChatEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.LOAD_CHAT;
    chatId: string;
}
interface IChatAgentNavigateToEvent extends IChatAgentBaseEvent {
    type: EChatAgentMessageEventType.NAVIGATE_TO;
    path: string;
    chatId?: string; // Für Chat-Wiederherstellung nach Navigation
}

export type TChatAgentEvent =
    | IChatAgentMessageEvent
    | IChatAgentInitEvent
    | IChatAgenStartChatEvent
    | IChatAgentTitleGeneratedEvent
    | IChatAgentGetChatListEvent
    | IChatAgentChatListResponseEvent
    | IChatAgentLoadChatEvent
    | IChatAgentNavigateToEvent;

export interface IChatAgentChat {
    chatId: string;
    employeeId: number;
    createdAt: string;
    createdBy: number;
    title?: string;
    currentModule?: EAgentModule;
    messages: {
        [key: string]: IChatAgentMessage;
    };
}

export interface IChatAgentChatMetadata {
    chatId: string;
    title: string;
    createdAt: string;
    lastMessageAt: string;
}

export const DEFAULT_CHAT_WELCOME_MESSAGES: Record<ELanguage, string> = {
    [ELanguage.de]: 'Hallo! Wie kann ich dir heute helfen?',
    [ELanguage.en]: 'Hello! How can I help you today?',
    [ELanguage.th]: 'สวัสดี! วันนี้ฉันช่วยอะไรคุณได้บ้าง?',
};
